module.exports = __webpack_public_path__ + "static/media/squiggle.27abf1c8.mp3";